import { Component, inject, input } from '@angular/core';
import * as fromSeriousSystem from '@serious-system';
import { TabsComponent } from '@serious-system';
import { RouterService } from '../shared/services/router.service';
import { AssistantsPageTab } from './assistants.helper';

@Component({
  selector: 'squadbox-assistants-tabs',
  standalone: true,
  imports: [TabsComponent],
  template: `
    <sd-tabs
      [tabOptions]="tabOptions()"
      [isMobile]="isMobile()"
      [selectedTabKey]="selectedTabKey()"
      [showBorderBottomNeutral]="!isMobile()"
      (tabClicked)="handleClickTabCTA($event)"
    />
  `,
})
export class AssistantsTabsComponent {
  private readonly routerService = inject(RouterService);

  public readonly tabOptions =
    input.required<fromSeriousSystem.TabOption<AssistantsPageTab>[]>();
  public readonly isMobile = input.required<boolean>();
  public readonly selectedTabKey = input.required<AssistantsPageTab>();

  public async handleClickTabCTA(
    tab: fromSeriousSystem.TabOption<AssistantsPageTab>,
  ) {
    await this.routerService.navigateToAssistants(tab.key);
  }
}
